export default "__VITE_ASSET__B2tPp6L3__"